module.exports = __webpack_public_path__ + "static/media/meest-app_2screen.c15fc5a4.png";